import styles from "../styles.module.css";
import { CALIFICATIONS } from "../../../utils/constants";
import { ReactComponent as BuffIcon } from "../../../assets/icons/buff-calification.svg";
import { ReactComponent as StarIcon } from "../../../assets/icons/star-icon.svg";
import { Form, Select } from "antd";

const conditionalRatingOptions = [
  {
    id: 1,
    name: "Más de 3 estrellas",
  },
  {
    id: 2,
    name: "Igual a 3 estrellas",
  },
  {
    id: 3,
    name: "Menos de 3 estrellas",
  },
];

const RatingTypeSurvey = ({ showConditional }) => {
  return (
    <div className={styles["survey-question-calification-container"]}>
      <div className={styles["survey-question-calification-filters"]}>
        <Select
          className="select-icon"
          defaultValue={"buff"}
          options={[
            {
              label: (
                <article>
                  <BuffIcon style={{ height: 24, width: 24 }} />
                </article>
              ),
              value: "buff",
            },
            {
              label: (
                <article>
                  <StarIcon />
                </article>
              ),
              value: "star",
            },
          ]}
        />
        <Select
          defaultValue={5}
          options={[
            {
              label: 5,
              value: 5,
            },
            {
              label: 10,
              value: 10,
            },
          ]}
        />
      </div>

      {/* {showConditional && (
        <div className={styles["survey-calification-conditionals"]}>
          {conditionalRatingOptions.map((item) => (
            <div key={item.id} className={styles["survey-condition-item"]}>
              <span className={styles["survey-condition-title"]}>
                {item.name}
              </span>

              <div className={styles["survey-condition-goto"]}>
                <span>Ir a</span>
                <Form.Item style={{ marginBottom: 0 }}>
                  <Select placeholder="Escribir" />
                </Form.Item>
              </div>
            </div>
          ))}
        </div>
      )} */}
    </div>
  );
};

export default RatingTypeSurvey;
